<div class="bg-[#0a0f1c] text-white py-0 lg:py-16 px-6 md:px-12 lg:px-20">
  <div class="max-w-5xl mx-auto text-center">
    <h3 class="font-libre font-bold text-[22px] leading-[27px]">
      <span class="text-[#19E4E0] border-b-2 border-[#19E4E0] pb-[0.05rem] mr-[5px]">How it</span>
      <span class="text-white">Works</span>
    </h3>
    <h1 class="text-2xl md:text-3xl font-bold mt-2">
      Create Your Free Account & Start Your Adventure!
    </h1>
    <p class="text-gray-400 mt-3 text-sm md:text-base">
      Sign up now to unlock exclusive game tiers, play thrilling challenges, and compete
      for top leaderboard ranks.<br />
      Your journey to nonstop entertainment and epic gameplay starts here!
    </p>
  </div>

  <div class="mt-[5rem] grid grid-cols-1 md:grid-cols-3 lg:gap-[12rem] max-w-6xl mx-auto">
    <div class="relative flex flex-col items-center cursor-pointer" (click)="redirectToSignUp()">
      <div class="relative w-[20rem] h-[18rem] flex items-center justify-center">
        <svg class="absolute w-[25rem] h-[14rem] -translate-y-6" viewBox="0 0 320 220"
          xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="bgGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#0A0E1F" />
              <stop offset="0.55" stop-color="#13192E" />
            </linearGradient>

            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="14" result="blur" />
              <feFlood flood-color="#19E4E0" flood-opacity="0.14" result="flood" />
              <feComposite in="flood" in2="blur" operator="in" result="glow" />
              <feMerge>
                <feMergeNode in="glow" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          <path d="M56 36 L264 36
            C284 36 300 56 300 76
            L260 172
            C252 184 236 196 220 196
            L100 196
            C84 196 68 184 60 172
            L20 76
            C20 56 36 36 56 36 Z" fill="url(#bgGrad)" />

          <path
            d="M56 36 L264 36 C284 36 300 56 300 76 L260 172 C252 184 236 196 220 196 L100 196 C84 196 68 184 60 172 L20 76 C20 56 36 36 56 36 Z"
            fill="none" stroke="#0E1724" stroke-width="1" opacity="0.7" />
        </svg>

        <div class="absolute inset-0 flex flex-col items-center justify-end pb-[7rem]">
          <div
            class="w-[5rem] h-[5rem] flex items-center justify-center bg-[#0a0f1c] rounded-[0.5rem] border-[8px] border-[#13192E] shadow-[0px_4px_40px_0px_#19E4E04D] mb-[2rem] rotate-45">
            <span class="font-bold text-[2rem] -rotate-45">1</span>
          </div>

          <h3 class="font-semibold text-lg text-white mb-1">Register</h3>

          <p class="text-gray-400 text-sm text-center px-6 leading-snug max-w-[18rem]">
            Create a free profile easily by setting up your basic login details.
          </p>
        </div>
      </div>
    </div>

    <div class="relative flex flex-col items-center cursor-pointer" (click)="redirectToSignUp()">
      <div class="relative w-[20rem] h-[18rem] flex items-center justify-center">
        <svg class="absolute w-[25rem] h-[14rem] -translate-y-6" viewBox="0 0 320 220"
          xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="bgGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#0A0E1F" />
              <stop offset="0.55" stop-color="#13192E" />
            </linearGradient>

            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="14" result="blur" />
              <feFlood flood-color="#19E4E0" flood-opacity="0.14" result="flood" />
              <feComposite in="flood" in2="blur" operator="in" result="glow" />
              <feMerge>
                <feMergeNode in="glow" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          <path d="M56 36 L264 36
            C284 36 300 56 300 76
            L260 172
            C252 184 236 196 220 196
            L100 196
            C84 196 68 184 60 172
            L20 76
            C20 56 36 36 56 36 Z" fill="url(#bgGrad)" />

          <path
            d="M56 36 L264 36 C284 36 300 56 300 76 L260 172 C252 184 236 196 220 196 L100 196 C84 196 68 184 60 172 L20 76 C20 56 36 36 56 36 Z"
            fill="none" stroke="#0E1724" stroke-width="1" opacity="0.7" />
        </svg>

        <div class="absolute inset-0 flex flex-col items-center justify-end pb-[7rem]">
          <div
            class="w-[5rem] h-[5rem] flex items-center justify-center bg-[#0a0f1c] rounded-[0.5rem] border-[8px] border-[#13192E] shadow-[0px_4px_40px_0px_#19E4E04D] mb-[2rem] rotate-45">
            <span class="font-bold text-[2rem] -rotate-45">2</span>
          </div>

          <h3 class="font-semibold text-lg text-white mb-1">Claim Tokens</h3>

          <p class="text-gray-400 text-sm text-center px-6 leading-snug max-w-[18rem]">
            Get your welcome coin bundle instantly to start exploring the social lobby.
          </p>
        </div>
      </div>
    </div>

    <div class="relative flex flex-col items-center cursor-pointer" (click)="redirectToSignUp()">
      <div class="relative w-[20rem] h-[18rem] flex items-center justify-center">
        <svg class="absolute w-[25rem] h-[14rem] -translate-y-6" viewBox="0 0 320 220"
          xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="bgGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#0A0E1F" />
              <stop offset="0.55" stop-color="#13192E" />
            </linearGradient>

            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="14" result="blur" />
              <feFlood flood-color="#19E4E0" flood-opacity="0.14" result="flood" />
              <feComposite in="flood" in2="blur" operator="in" result="glow" />
              <feMerge>
                <feMergeNode in="glow" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          <path d="M56 36 L264 36
            C284 36 300 56 300 76
            L260 172
            C252 184 236 196 220 196
            L100 196
            C84 196 68 184 60 172
            L20 76
            C20 56 36 36 56 36 Z" fill="url(#bgGrad)" />

          <path
            d="M56 36 L264 36 C284 36 300 56 300 76 L260 172 C252 184 236 196 220 196 L100 196 C84 196 68 184 60 172 L20 76 C20 56 36 36 56 36 Z"
            fill="none" stroke="#0E1724" stroke-width="1" opacity="0.7" />
        </svg>

        <div class="absolute inset-0 flex flex-col items-center justify-end pb-[7rem]">
          <div
            class="w-[5rem] h-[5rem] flex items-center justify-center bg-[#0a0f1c] rounded-[0.5rem] border-[8px] border-[#13192E] shadow-[0px_4px_40px_0px_#19E4E04D] mb-[2rem] rotate-45">
            <span class="font-bold text-[2rem] -rotate-45">3</span>
          </div>

          <h3 class="font-semibold text-lg text-white mb-1">Enjoy the game</h3>

          <p class="text-gray-400 text-sm text-center px-6 leading-snug max-w-[18rem]">
            Start playing your favorite games and enjoy the experience!
          </p>
        </div>
      </div>
    </div>
  </div>
</div>